window.homeasapTest = window.location.href.indexOf('test') > -1 || window.location.href.indexOf('dev') > -1;
    var apiRoot = 'https://api.' + (window.homeasapTest ? 'test' : '') + 'homeasap.com/NPlay.Services.NPlayApi/api/';

    window.jQuery(function() {
        function setStatus(status) {
            window.jQuery('.pro-controlled-section').hide()
            window.jQuery('.pro-controlled-section.' + status).show()
        }
  
  function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

    if (getUrlParameter('guid')) {
    var autoAccessToken = getUrlParameter('guid');
    if (!autoAccessToken.match(/^ha/)) {
        autoAccessToken = 'ha-aa_' + autoAccessToken;
    }
    authAPI(autoAccessToken);
  } else {
        agentAPI();
  }

    function agentAPI() {
        setStatus('loading');

    window.jQuery.ajax({
        url: apiRoot + "agent",
    type: "GET",
    dataType: 'json',
    xhrFields: {
        withCredentials: true
        },
    crossDomain: true,
    success: function(data) {
        agentSearchAPI(data.agentId)
    },

    error: function() {
        setStatus('pro-not-logged-in')
    }
      });
    }

    function authAPI(token) {
        console.log('Welcome!  Fetching your information.... ');
    setStatus('loading');

    window.jQuery.ajax({
        url: apiRoot + "agentauth",
    type: "POST",
    dataType: 'json',
    xhrFields: {
        withCredentials: true
        },
    crossDomain: true,
    data: {
        '': token
        },
    success: function(data) {
        agentSearchAPI(data.AgentId);
        },

    error: function(jqXHR, status, thrownError) {
        setStatus('pro-not-logged-in')
    }
      });
    }


    function agentSearchAPI(agentId) {

        window.jQuery.ajax({
            url: apiRoot + "agentsearch/getagent/?id=" + agentId,
            type: "GET",
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            },
            crossDomain: true,
            success: function (data) {
                if ((data && data.ProductServices || []).indexOf('PC') > -1 ||
                    (data && data.ProductServices || []).indexOf('PM') > -1 ||
                    (data && data.ProductServices || []).indexOf('PRO') > -1) {
                    setStatus('pro-logged-in')
                } else {
                    setStatus('no-pro')
                }
            },

            error: function () {
                setStatus('no-pro')
            }
        });
    }

    window.HomeASAPAccountsAsyncInit = function () {
    }

    window.HomeASAPAccountsStatusChangeCallback = function (data) {
      if (data && data.status) {
        if (data.status.match(/_SUCCESS$/) && typeof data.token === 'string') {
        authAPI(data.token);
        }
      }
    }

    window.jQuery('.homeasap-login-button').click(function(e) {
        e.preventDefault();
    window.HomeASAPAccounts.agentLogin();
    })
  });

    // Load HomeASAP Accounts
    ;(function (w, d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    w.HomeASAPAccountsOrigin = w.location.origin;
    if (d.getElementById(id)) { return; }
    js = d.createElement(s); js.id = id;
    js.src = "https://accounts." + (window.homeasapTest ? 'test' : '') + "homeasap.com/sdk/index.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(window, document, 'script', 'homeasap-accounts-js'));
